<template>
  <div>
    <!--筛选栏-->
    <Row type="flex" :space-x="10" class="margin-right-left padding-top" align="middle">
      <Cell>
        <Select v-model="filter.type" :allow-clear="true" style="width:120px" placeholder="单据类型">
          <Option :value="1">收款单</Option>
          <Option :value="2">付款单</Option>
          <Option :value="3">退款单</Option>
        </Select>
      </Cell>
      <Cell>
        <DatePicker v-model="filter.start" format="yyyy-MM-dd" placeholder="开始日期" style="width:140px"></DatePicker>
      </Cell>
      <Cell>
        <DatePicker v-model="filter.end" format="yyyy-MM-dd" placeholder="结束日期" style="width:140px"></DatePicker>
      </Cell>
      <Cell>
        <Button color="primary" @click="loadList">查询</Button>
      </Cell>
      <Cell>
        <Button color="success" @click="openAdd">新增资金单</Button>
      </Cell>
      <Cell>
        <Button @click="doPreview" :disabled="!selectedIds.length">凭证预览</Button>
      </Cell>
      <Cell>
        <Button color="primary" @click="doGenerate" :disabled="!selectedIds.length">生成凭证</Button>
      </Cell>
    </Row>

    <!--列表-->
    <div class="h-panel-body padding-top">
      <Table :datas="list" :border="true" :loading="loading" multiSelect @selection-change="onSelect">
        <TableItem type="check" width="50" :prop="'id'"></TableItem>
        <TableItem title="单据编号" prop="code" :width="170"></TableItem>
        <TableItem title="单据日期" prop="billDate" :width="110"></TableItem>
        <TableItem title="类型" :width="90" align="center">
          <template slot-scope="{data}">
            <Tag :color="typeColor(data.type)">{{ typeName(data.type) }}</Tag>
          </template>
        </TableItem>
        <TableItem title="收/付款账户" prop="accountName" :width="140"></TableItem>
        <TableItem title="对方单位" prop="supplierName" :width="160"></TableItem>
        <TableItem title="金额" align="right">
          <template slot-scope="{data}">{{ money(data.amount) }}</template>
        </TableItem>
        <TableItem title="摘要" prop="summary"></TableItem>
        <TableItem title="状态" :width="110" align="center">
          <template slot-scope="{data}">
            <Tag :color="data.status === 2 ? 'success' : 'warning'">
              {{ data.status === 2 ? '已生成凭证' : '未生成凭证' }}
            </Tag>
          </template>
        </TableItem>
        <TableItem title="操作" :width="80" align="center">
          <span slot-scope="{data}" class="link danger" @click="doDelete(data)">删除</span>
        </TableItem>
      </Table>
      <Pagination :page="filter.page" size="small" :total="total" @change="onPage" class="margin-top text-right"></Pagination>
    </div>

    <!--编辑弹窗-->
    <Modal v-model="modal" title="新增资金单" width="700">
      <Form ref="form" label-width="120" :model="form" :rules="validationRules">
        <FormItem label="单据类型" prop="type">
          <Radio type="button" v-model="form.type" :datas="typeDatas"></Radio>
        </FormItem>
        <FormItem label="单据日期" prop="billDate">
          <DatePicker v-model="form.billDate" format="yyyy-MM-dd"></DatePicker>
        </FormItem>
        <FormItem label="收/付款账户" prop="accountId">
          <Select v-model="form.accountId" filterable>
            <Option v-for="a in accounts" :value="a.id" :key="a.id">{{ a.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="对方单位" prop="supplierId">
          <Select v-model="form.supplierId" filterable>
            <Option v-for="s in suppliers" :value="s.id" :key="s.id">{{ s.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="金额" prop="amount">
          <input type="number" v-model.number="form.amount">
        </FormItem>
        <FormItem label="摘要">
          <input type="text" v-model="form.summary" placeholder="不填则自动生成">
        </FormItem>
        <FormItem label="备注">
          <textarea v-model="form.remark" rows="2"></textarea>
        </FormItem>
      </Form>
      <div slot="bottom">
        <Button @click="modal = false">取消</Button>
        <Button color="primary" @click="doSave" :loading="saving">保存</Button>
      </div>
    </Modal>

    <!--凭证预览-->
    <Modal v-model="previewModal" title="凭证预览" width="760">
      <div v-for="(v, i) in previewList" :key="i">
        <div class="voucher-title">资金单：{{ v.orderCode }}</div>
        <Table :datas="v.lines" :border="true">
          <TableItem title="摘要" prop="summary"></TableItem>
          <TableItem title="科目" prop="subjectName"></TableItem>
          <TableItem title="借方" prop="jie" align="right"></TableItem>
          <TableItem title="贷方" prop="dai" align="right"></TableItem>
        </Table>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'InventoryFund',
  data() {
    return {
      filter: {type: null, start: '', end: '', page: 1},
      list: [],
      total: 0,
      loading: false,
      selectedIds: [],
      accounts: [],
      suppliers: [],
      modal: false,
      saving: false,
      form: this.blankForm(),
      validationRules: {
        required: ['type', 'billDate', 'accountId', 'supplierId', 'amount']
      },
      typeDatas: [{key: 1, title: '收款单'}, {key: 2, title: '付款单'}, {key: 3, title: '退款单'}],
      previewModal: false,
      previewList: []
    };
  },
  methods: {
    blankForm() {
      return {
        type: 1, billDate: new Date(), accountId: null, supplierId: null,
        amount: 0, summary: '', remark: ''
      };
    },
    money(val) {
      let n = Number(val);
      return isNaN(n) ? '0.00' : n.toFixed(2);
    },
    typeName(type) {
      return {1: '收款单', 2: '付款单', 3: '退款单'}[type] || '-';
    },
    typeColor(type) {
      return {1: 'success', 2: 'error', 3: 'warning'}[type] || '';
    },
    loadOptions() {
      this.$api.funds.account.list().then(({data}) => {
        this.accounts = data.records || data.results || data || [];
      }).catch(() => {});
      this.$api.setting.inventorySupplier.list({page: 1, size: 500}).then(({data}) => {
        this.suppliers = data.records || data.results || data || [];
      }).catch(() => {});
    },
    loadList() {
      this.loading = true;
      let params = Object.assign({page: this.filter.page, pageSize: 20}, this.filter);
      this.$api.pro.inventoryFund.list(params).then(({data}) => {
        this.list = data.results || [];
        this.total = data.total || 0;
      }).finally(() => this.loading = false);
    },
    onPage(page) {
      this.filter.page = page;
      this.loadList();
    },
    onSelect(selection) {
      this.selectedIds = selection.map(r => r.id);
    },
    openAdd() {
      this.form = this.blankForm();
      this.modal = true;
    },
    doSave() {
      let validResult = this.$refs.form.valid();
      if (!validResult.result) {
        return;
      }
      if (!(Number(this.form.amount) > 0)) {
        this.$Message.warning('请填写大于 0 的金额');
        return;
      }
      this.saving = true;
      this.$api.pro.inventoryFund.save(this.form).then(() => {
        this.$Message.success('资金单保存成功');
        this.modal = false;
        this.loadList();
      }).finally(() => this.saving = false);
    },
    doDelete(data) {
      this.$Confirm(`确认删除资金单 ${data.code}？`).then(() => {
        this.$api.pro.inventoryFund.del(data.id).then(() => {
          this.$Message.success('删除成功');
          this.loadList();
        });
      });
    },
    doPreview() {
      this.$api.pro.inventoryFund.preview(this.selectedIds).then(({data}) => {
        this.previewList = data || [];
        this.previewModal = true;
      });
    },
    doGenerate() {
      this.$Confirm('确认为所选资金单生成凭证？').then(() => {
        this.$api.pro.inventoryFund.generate(this.selectedIds).then(({data}) => {
          this.$Message.success(data || '凭证生成成功');
          this.loadList();
        });
      });
    }
  },
  mounted() {
    this.loadOptions();
    this.loadList();
  }
}
</script>

<style lang="less" scoped>
.margin-top {
  margin-top: 10px;
}
.link {
  color: #2d8cf0;
  cursor: pointer;
  margin: 0 5px;
  &.danger {
    color: #ed4014;
  }
}
.voucher-title {
  margin: 10px 0;
  font-weight: bold;
}
</style>
